// Screen disconnect diagnostic codes — mirror of
// backend/app/core/disconnect_codes.py and
// android/app/src/main/java/com/wetook/app/ui/DisconnectCode.kt.
//
// Shown on the player when a screen leaves normal playback so a customer can
// read the number to their Account Manager, who maps it to the cause.
//   1xx connectivity (client-assigned) · 2xx licensing · 3xx lifecycle · 9xx server
export const DISCONNECT_CODES = {
  NO_INTERNET:        110,
  SERVER_UNREACHABLE: 120,
  LICENSE_EXPIRED:    210,
  LICENSE_DESYNC:     220,
  NO_LICENSE:         230,
  DEACTIVATED:        310,
  REMOVED:            320,
  DETACHED:           330,
  SERVER_ERROR:       910,
  UNKNOWN:            990,
} as const

// Machine reason string (device_orphaned payload / X-Disconnect-Reason header)
// → numeric code. Falls back to UNKNOWN.
export function codeForReason(reason?: string | null): number {
  switch (reason) {
    case 'no_internet':        return DISCONNECT_CODES.NO_INTERNET
    case 'server_unreachable': return DISCONNECT_CODES.SERVER_UNREACHABLE
    case 'license_expired':    return DISCONNECT_CODES.LICENSE_EXPIRED
    case 'license_desync':     return DISCONNECT_CODES.LICENSE_DESYNC
    case 'no_license':         return DISCONNECT_CODES.NO_LICENSE
    case 'deactivated':        return DISCONNECT_CODES.DEACTIVATED
    case 'removed':            return DISCONNECT_CODES.REMOVED
    case 'detached':           return DISCONNECT_CODES.DETACHED
    case 'server_error':       return DISCONNECT_CODES.SERVER_ERROR
    default:                   return DISCONNECT_CODES.UNKNOWN
  }
}
